import { ShippingAddressSelector as ShippingAddressSelectorShared } from '../../../../components/Containers/ReviewCheckoutDrawer/ShippingAddress/ShippingAddressSelector';
import { useFlow } from '../../../../providers';
import { usePreAuthOfferCtx } from '../../../../providers/PreAuthOfferProvider';

export const ShippingAddressSelector = () => {
  const { addresses, selectedAddressId, setSelectedAddressId } =
    usePreAuthOfferCtx();
  const { goToStep } = useFlow();

  return (
    <ShippingAddressSelectorShared
      addresses={addresses?.addresses || []}
      onUpdate={() => {
        goToStep('review');
      }}
      selectedAddressId={selectedAddressId}
      setSelectedAddressId={setSelectedAddressId}
    />
  );
};
